
export default {
    styleOverrides: {
      root: {
        backgroundColor: "#ffffff",
        color: "#000000",
        boxShadow: "none",
      },
    },
}